/**
 * @file index.tsx
 *
 * @fileoverview Renders BlogTeaser inside Cell component from jobiqo CL.
 */ import { FormattedMessage } from 'react-intl';
import AnchorDiv from '~/jobiqo/components/AnchorDiv';
import { getReducedSummary } from '~/jobiqo/components/Blog/utils';
import Image from '~/jobiqo/components/Image';
import Link from '~/jobiqo/components/Link';
import { BlogPost } from '~/jobiqo/models/blog';
import { getCommonTranslations } from '~/jobiqo/utils/intl';
import { Cell } from '~/vcl/atoms/06-layout/04-grid/01-cell';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';
import { BlogTeaser } from '~/vcl/organisms/11-blog/01-blog-teaser';

interface BlogSearchBlogTeaserCellProps {
  /**
   * The blog post.
   */
  blogPost: BlogPost;
}
export default function BlogSearchBlogTeaserCell({
  blogPost: { id, image, title, category, url, summary, featured },
}: BlogSearchBlogTeaserCellProps) {
  const { ADVERTORIAL_LABEL } = getCommonTranslations();

  return (
    <Cell key={id} display="grid">
      <AnchorDiv route={url.path}>
        <BlogTeaser
          {...(image?.url && {
            banner: (
              <Image
                src={image?.url}
                height={300}
                width={600}
                alt={image.alt ?? ''}
                {...(image.title && { title: image.title })}
              />
            ),
          })}
          title={
            <Link href={url.path} target="_blank">
              {title}
            </Link>
          }
          content={
            summary ? (
              <WYSIWYGText
                format="full_html"
                content={getReducedSummary(summary)}
              />
            ) : (
              ''
            )
          }
          {...(category && { categories: [category.label] })}
          actions={
            <Link href={url.path} target="_blank">
              <FormattedMessage id="blog_see_more" defaultMessage="See more" />
            </Link>
          }
          {...(featured && {
            advertorialLabel: ADVERTORIAL_LABEL,
          })}
        />
      </AnchorDiv>
    </Cell>
  );
}
export { BlogSearchBlogTeaserCell };
